export {};

/*
 * Аудиоплеер на основе YandexAudio API
 * @param player
 * @param data
 * @constructor
 */
var NlmkAudioPlayer = function(player, data) {
    this.audioPlayer = null;
    this.moveVolume = false;

    if (data.url) {
        this.url = data.url;
    } else {
        console.error("Не задан audio файл для проигрывания");
        return;
    }

    if(player){
        this.player = player;
    } else {
        console.error("Не указан объект плеера");
        return;
    }

    this.htmlPlayerDom = {
        player: player,
        play: player.querySelector(data.play ? data.play : ".nlmk-audio-player__play"),
        time: player.querySelector(data.time ? data.time : ".nlmk-audio-player__time"),
        progress: {
            bar: player.querySelector(data.progress_bar ? data.progress_bar : ".nlmk-audio-player__progress"),
            loaded: player.querySelector(data.progress_loaded ? data.progress_loaded : ".nlmk-audio-player__progress--loaded"),
            current: player.querySelector(data.progress_current ? data.progress_current : ".nlmk-audio-player__progress--current")
        },
        volume: {
            bar: player.querySelector(data.volume_bar ? data.volume_bar : ".nlmk-audio-player__volume"),
            value: player.querySelector(data.volume_value ? data.volume_value : ".nlmk-audio-player__volume-bar"),
            switch: player.querySelector(data.volume_value ? data.volume_value : ".nlmk-audio-player__volume-switch"),
            num: player.querySelector(data.volume_num ? data.volume_num : ".nlmk-audio-player__volume-value"),
        }
    };

    this.initPlayer();
    this.initEvent();
}

/**
 * Инициализация плеера. первоначальные настройки
 */
NlmkAudioPlayer.prototype.initPlayer = function() {
    var self = this;

    this.audioPlayer = new ya.music.Audio("html5", null);
    this.audioPlayer.initPromise().then(function() {
        self.updateVolume(self.audioPlayer.getVolume());
    });

}

/**
 * Инициализация событый для плеера и взаимодействия с ним
 */
NlmkAudioPlayer.prototype.initEvent = function () {
    this.audioPlayer.on(ya.music.Audio.EVENT_STATE, $.proxy(this.changeStatePlayer, this));
    this.audioPlayer.on(ya.music.Audio.EVENT_VOLUME, $.proxy(this.updateVolume, this));
    this.audioPlayer.on(ya.music.Audio.EVENT_PROGRESS, $.proxy(this.changeProgress,this));
    this.audioPlayer.on(ya.music.Audio.EVENT_ENDED, $.proxy(this.endPlaying, this));

    $(this.htmlPlayerDom.play).on("click", $.proxy(this.clickModePlay, this));
    $(this.htmlPlayerDom.volume.bar).on("click", $.proxy(this.clickVolumeBar, this));
    $(this.htmlPlayerDom.progress.bar).on("click", $.proxy(this.clickProgressBar, this));

    console.log(this.htmlPlayerDom.volume.switch);
    $(this.htmlPlayerDom.volume.switch).on("mousedown", $.proxy(this.clickDownSwitch, this));
    $(document).on("mouseup", $.proxy(this.clickUpSwitch, this))
}

/**
 * Функция обновления звука
 */
NlmkAudioPlayer.prototype.updateVolume = function(volume) {
    this.htmlPlayerDom.volume.value.style.width = (volume * 100).toFixed(2) + "%";
    this.htmlPlayerDom.volume.num.innerHTML = Math.trunc((volume * 100).toFixed(2)) + "%";
};

/*
 * Фукнция устанавливает оставшееся время
 * @param time
 */
NlmkAudioPlayer.prototype.setDuration = function(time) {
    this.htmlPlayerDom.time.innerHTML = time;
}

/*
 * Метот срабатывает при изменении состяния плеера
 * @param time
 */
NlmkAudioPlayer.prototype.changeStatePlayer = function(state) {
    if (state === ya.music.Audio.STATE_PLAYING) {
        this.htmlPlayerDom.player.classList.add("nlmk-audio-player--playing");
    } else {
        this.htmlPlayerDom.player.classList.remove("nlmk-audio-player--playing");
    }

    if (state == ya.music.Audio.STATE_IDLE) {
        this.setDuration(this.formatTime(this.audioPlayer.getDuration()));
    }
}

/**
 * Метод окончания воспроизведения
 */
NlmkAudioPlayer.prototype.endPlaying = function() {
    this.changeProgress(null);
}

/**
 * Метод сраатывает при нажатии на кнопку проигрывания
 */
NlmkAudioPlayer.prototype.clickModePlay = function() {
    var state = this.audioPlayer.getState();

    switch (state) {
        case ya.music.Audio.STATE_PLAYING:
            this.audioPlayer.pause();
            break;
        case ya.music.Audio.STATE_PAUSED:
            this.audioPlayer.resume();
            break;
        default:
            this.audioPlayer.play(this.url);
            break;
    }
}

/**
 * Метод при клике на ползунок с громкостью
 * @param evt
 */
NlmkAudioPlayer.prototype.clickVolumeBar = function(evt) {
    var fullWidth = this.htmlPlayerDom.volume.bar.offsetWidth;
    var offset = $(this.htmlPlayerDom.volume.bar).offset().left;
    var volume = Math.max(0, Math.min(1, ((evt.pageX || evt.screenX) - offset) / fullWidth));
    this.audioPlayer.setVolume(volume);
}

/**
 * Метод при клике на полосу проигрывания
 * @param evt
 */
NlmkAudioPlayer.prototype.clickProgressBar = function(evt) {
    var fullWidth = this.htmlPlayerDom.progress.bar.offsetWidth;
    var offset = $(this.htmlPlayerDom.progress.bar).offset().left;
    var relativePosition = Math.max(0, Math.min(1, ((evt.pageX || evt.screenX) - offset) / fullWidth));
    this.audioPlayer.setPosition(this.audioPlayer.getDuration() * relativePosition);
}

/**
 * Метод изменения прогресса
 * @param timings
 */
NlmkAudioPlayer.prototype.changeProgress = function(timings) {
    if(timings){
        this.htmlPlayerDom.progress.loaded.style.width = (timings.loaded / timings.duration * 100).toFixed(2) + "%";
        this.htmlPlayerDom.progress.current.style.width = (timings.position / timings.duration * 100).toFixed(2) + "%";

        if(timings.duration === 0 && timings.played === 0) {
            this.setDuration(this.formatTime(this.audioPlayer.getDuration()));
        }else {
            this.setDuration(this.formatTime(timings.duration - timings.position));
        }
    } else {
        this.htmlPlayerDom.progress.current.style.width = "0%";
        this.setDuration(this.formatTime(this.audioPlayer.getDuration()));
    }

}

/**
 * Метод при взаимодействии мышкой с громкостью
 * @param evt
 */
NlmkAudioPlayer.prototype.moveSwitch = function(evt) {
    var fullWidth = this.htmlPlayerDom.volume.bar.offsetWidth;
    var offset = $(this.htmlPlayerDom.volume.bar).offset().left;
    var volume = Math.max(0, Math.min(1, ((evt.pageX || evt.screenX) - offset) / fullWidth));
    this.htmlPlayerDom.volume.value.style.width = (volume * 100).toFixed(2) + "%";
    this.htmlPlayerDom.volume.num.innerHTML = Math.trunc((volume * 100).toFixed(2)) + "%";
}

/**
 * Метод при нажатии на тумблер громкости
 * @param evt
 */
NlmkAudioPlayer.prototype.clickDownSwitch = function(evt) {
    this.moveVolume = true;
    this.moveSwitchHandler = this.moveSwitch.bind(this);
    document.addEventListener('mousemove', this.moveSwitchHandler);
}

/**
 * Метод при прекращении взаимодействия с тумблером громскости
 * @param evt
 */
NlmkAudioPlayer.prototype.clickUpSwitch = function(evt) {
    if(this.moveVolume) {
        this.moveVolume = false;
        document.removeEventListener('mousemove', this.moveSwitchHandler);
    }
}

/**
 * Метод для форматирования вермени в человекопонятном формате
 * @param time
 * @returns {string}
 */
NlmkAudioPlayer.prototype.formatTime = function(time) {
    var result = [];
    var hours = Math.floor(time / 60 / 60);
    var minutes = (Math.floor(time / 60) - (hours * 60)).toString().padStart(2, '0');
    var seconds = (Math.trunc(time % 60)).toString().padStart(2, '0');
    hours = hours.toString().padStart(2, '0');
    if(hours != "00"){
        result.push(hours);
    }

    result.push(minutes);
    result.push(seconds);

    return result.join(':');
}

$(document).ready(function(){
    $(".js-nlmk-audio-player").each(function(){
        $(this).data("audio-object", new NlmkAudioPlayer(this, {
            "url": $(this).attr("src"),
        }));
    });
});



// WEBPACK FOOTER //
// ./js/main/module/audioplayer.js